import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Popover } from 'antd'
import { signOut } from 'redux/Admin/actions'

class UserInfo extends Component {
    state = {
        visible: false
    }

    hidePopover = () => {
        this.setState({
            visible: false
        })
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    render() {
        const userMenuOptions = (
            <ul className="gx-user-popover">
                <Link to="/account" style={{ color: 'inherit', display: 'block' }} onClick={this.hidePopover}>
                    <li>Settings</li>
                </Link>
                <li onClick={() => this.props.signOut()}>Logout</li>
            </ul>
        )

        const { organization } = this.props.me

        return (
            <Popover
                placement="bottomRight"
                content={userMenuOptions}
                trigger="click"
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
            >
                <span className="gx-avatar-name">
                    {organization}
                    <i className="icon icon-chevron-down gx-fs-xxs gx-ml-2" />
                </span>
            </Popover>
        )
    }
}

const mapStateToProps = ({ admin }) => ({
    me: admin.me
})

const mapActionsToProps = dispatch => ({
    signOut: bindActionCreators(signOut, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(UserInfo)
